/** Golden bell (fx 'bell'): a dome rings out around the caster. */
import { registerFx } from './registry';

registerFx('bell', (host) => ({
  skill: ({ s, sx, sy }) => {
    host.fx.push({
      type: 'shock',
      x: sx,
      y: sy,
      t: 0,
      life: 0.7,
      r: (s.aoe ?? 1.3) * 28,
      col: '255,214,110',
    });
    host.fx.push({ type: 'sigil', x: sx, y: sy, t: 0, life: 1, r: 24, col: '255,214,110' });
    for (let k = 0; k < 3; k++)
      host.fx.push({
        type: 'ring',
        x: sx,
        y: sy - 20,
        t: -k * 0.12,
        life: 0.5,
        r: 30 + k * 8,
        col: '255,230,150',
      });
    host.sfx.train();
  },
}));
